











import { Vue, Component } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";

@Component({ components: { Navbar } })
export default class App extends Vue {
  get contentContainerClass() {
    return {
      "with-navbar-margin": this.$route.name !== "Home"
    };
  }
}
